import React from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { Scrollbars } from 'react-custom-scrollbars';
class Contact extends React.Component {
    componentDidMount(){
        document.title = "Get in Touch - Tunis React Personal Portfolio";
        window.scrollTo(0,0);
    }
    render() {
        return (
            <Scrollbars>
                <div className="contact">
                    <section className="title-section text-left text-sm-center">
                        <h1>get in <span>touch</span></h1>
                        <span className="title-bg">contact</span>
                    </section>
                    <section className="main-content">
                        <Container>
                            <Row>
                                <Col lg={4}>
                                    <h3 className="text-uppercase custom-title mb-0 ft-wt-600 pb-3">Don't be shy !</h3>
                                    <p className="open-sans-font mb-3">Feel free to get in touch with me. I am always open
                                        to discussing new projects, creative ideas or opportunities to be part of your
                                        visions.</p>
                                    <p className="open-sans-font custom-span-contact position-relative">
                                        <i className="fa fa-envelope-open position-absolute"></i>
                                        <span className="d-block">mail me</span>steve@mail.com
                                    </p>
                                    <p className="open-sans-font custom-span-contact position-relative">
                                        <i className="fa fa-phone-square position-absolute"></i>
                                        <span className="d-block">call me</span>+216 21 184 010
                                    </p>
                                    <ul className="social list-unstyled pt-1 mb-5">
                                        <li className="facebook"><a title="Facebook" href="#"><i
                                            className="fa fa-facebook"></i></a>
                                        </li>
                                        <li className="twitter"><a title="Twitter" href="#"><i
                                            className="fa fa-twitter"></i></a>
                                        </li>
                                        <li className="youtube"><a title="Youtube" href="#"><i
                                            className="fa fa-youtube"></i></a>
                                        </li>
                                        <li className="dribbble"><a title="Dribbble" href="#"><i
                                            className="fa fa-dribbble"></i></a>
                                        </li>
                                    </ul>
                                </Col>
                                <Col lg={8}>
                                    <form>
                                        <div className="contactform">
                                            <Row>
                                                <Col md={4}>
                                                    <Form.Control type="text"  placeholder="YOUR NAME" autoComplete="off" />
                                                </Col>
                                                <Col md={4}>
                                                    <Form.Control type="email"  placeholder="YOUR EMAIL" autoComplete="off" />
                                                </Col>
                                                <Col md={4}>
                                                    <Form.Control type="text"  placeholder="YOUR SUBJECT" autoComplete="off" />
                                                </Col>
                                                <Col xs={12}>
                                                    <textarea name="message" placeholder="YOUR MESSAGE"></textarea>
                                                    <button type="submit" className="btn btn-contact"><span>Send Message</span></button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </form>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                </div>
            </Scrollbars>
        )
    }
}

export default Contact